import React from 'react'
import { createStyles, withStyles } from "@mui/styles"
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'
import { compose } from 'widgets-shared/core'
import { Props } from './types'
import { Typography } from '@mui/material'

const styles = () => createStyles({
  textContainer: {},
  container: {},
})

export const DynamicText = (props: Props) => {
  const {
    classes,
    text,
    component,
    children
  } = props
  const textToTransform = text || children
  const splitText = textToTransform ? textToTransform.split('|') : ''
  return splitText &&
    <div className={`${classes.container}`}>
      {
        splitText.map((textElement, index) => <Typography component={component} className={classes.textContainer} key={index}>{textElement}</Typography>)
      }
    </div>
}

export default compose(
  withStyles(styles, { name: 'DynamicText', withTheme: true, defaultTheme: getDefaultTheme })
)(DynamicText)
